import { gql } from "@apollo/client";
import { GET_EMPLOYEE, GET_MEDICAL, GET_VISA } from "../fragments/processes";

export const ADD_UPDATE_EMPLOYEE = gql`
  ${GET_EMPLOYEE}
  mutation createEmployee(
    $_id: String
    $status: EmployeeStatus!
    $givenName: String
    $surName: String
    $passportNumber: String
    $placeOfBirth: String
    $placeOfIssue: String
    $sex: Sex!
    $dateOfBirth: DateTime
    $passportIssueDate: DateTime
    $passportExpiryDate: DateTime
    $visa: VisaInput
    $documents: [RequiredDocuments!]
    $address: AddressInput
    $contactPerson: ContactInput
    $additionalData: AdditionalDataInput
    $education: EducationInput
    $embassyProcess: EmbassyProcessInput
    $flight: FlightProcessInput
    $workExperience: [WorkExperienceInput!]
    $owner: CompanyInput
    $prospects: [CompanyInput!]
    $firstTestimonialName: String
    $firstTestimonialAddress: String
    $firstTestimonialTelephone: String
    $secondTestimonialName: String
    $secondTestimonialAddress: String
    $secondTestimonialTelephone: String
  ) {
    createEmployee(
      input: {
        _id: $_id
        status: $status
        givenName: $givenName
        surName: $surName
        passportNumber: $passportNumber
        placeOfBirth: $placeOfBirth
        placeOfIssue: $placeOfIssue
        sex: $sex
        dateOfBirth: $dateOfBirth
        passportIssueDate: $passportIssueDate
        passportExpiryDate: $passportExpiryDate
        documents: $documents
        address: $address
        visa: $visa
        contactPerson: $contactPerson
        additionalData: $additionalData
        education: $education
        embassyProcess: $embassyProcess
        flight: $flight
        workExperience: $workExperience
        owner: $owner
        prospects: $prospects
        firstTestimonialName: $firstTestimonialName
        firstTestimonialAddress: $firstTestimonialAddress
        firstTestimonialTelephone: $firstTestimonialTelephone
        secondTestimonialName: $secondTestimonialName
        secondTestimonialAddress: $secondTestimonialAddress
        secondTestimonialTelephone: $secondTestimonialTelephone
      }
    ) {
      ...getEmployee
    }
  }
`;
export const REMOVE_EMPLOYEE = gql`
  mutation removeAnEmployee($id: String!) {
    deleteEmployee(id: $id) {
      affectedRows
    }
  }
`;
export const ADD_UPDATE_VISA = gql`
  ${GET_VISA}
  mutation createVisa(
    $_id: String
    $visaNumber: String!
    $visaQty: Int!
    $fullName: String!
    $passportNumber: String
    $salary: Int
    $remarks: String
    $firstTime: Boolean!
    $goodLooking: Boolean!
    $writeRead: Boolean!
    $currency: CurrencyTypes!
    $profession: ProfessionalTypes!
    $religion: ReligionTypes!
    $ageCategory: AgeCategory!
    $complexion: Complexion!
    $status: MedicalPaymentStatus!
    $visaType: MedicalPaymentTypes
    $address: AddressInput
    $owner: CompanyInput
  ) {
    createVisa(
      input: {
        _id: $_id
        visaNumber: $visaNumber
        fullName: $fullName
        passportNumber: $passportNumber
        visaQty: $visaQty
        salary: $salary
        currency: $currency
        remarks: $remarks
        firstTime: $firstTime
        goodLooking: $goodLooking
        writeRead: $writeRead
        profession: $profession
        religion: $religion
        ageCategory: $ageCategory
        complexion: $complexion
        status: $status
        visaType: $visaType
        address: $address
        owner: $owner
      }
    ) {
      ...getVisa
    }
  }
`;

export const REMOVE_VISA = gql`
  mutation removeAVisa($id: String!) {
    deleteVisa(id: $id) {
      affectedRows
    }
  }
`;

export const ADD_UPDATE_MEDICAL = gql`
  ${GET_MEDICAL}
  mutation createMedicalPayment(
    $_id: String
    $orderedAt: DateTime
    $screenshotLink: String
    $transferReason: String
    $totalAmount: Float
    $remarks: String
    $status: MedicalPaymentStatus
    $details: [MedicalDetailInput!]
    $user: CreateUserInput
  ) {
    createMedicalPayment(
      input: {
        _id: $_id
        orderedAt: $orderedAt
        screenshotLink: $screenshotLink
        transferReason: $transferReason
        totalAmount: $totalAmount
        details: $details
        status: $status
        remarks: $remarks
        user: $user
      }
    ) {
      ...getMedicalPayment
    }
  }
`;

export const REMOVE_MEDICAL = gql`
  mutation removeAMedicalPayment($id: String!) {
    deleteMedicalPayment(id: $id) {
      affectedRows
    }
  }
`;

export const GENERATE_LINK = gql`
  mutation generateLink($ids: [String!]!) {
    generateLink(input: { employeeIds: $ids }) {
      _id
      link

      employees {
        _id
        givenName
      }
    }
  }
`;

export const SHARE_BY_EMAIL = gql`
  mutation shareLinkByEmail($email: String, $link: String) {
    shareLinkByEmail(input: { email: $email, link: $link }) {
      email
      link
    }
  }
`;

export const LINK_EMPLOYEE_VISA = gql`
  ${GET_EMPLOYEE}

  mutation assignEmployeeVisa($ids: [String!]!) {
    assignEmployeeVisa(input: { ids: $ids }) {
      ...getEmployee
    }
  }
`;
